import { useEffect } from 'react';

import Modal from '@mui/material/Modal';

import { colors, zIndex } from 'styles';

import { Backdrop, Box } from '@mui/material';

type DownloadBriefModalProps = { onClose: () => void; isOpen: boolean };

export const DownloadBriefModal = ({ isOpen, onClose }: DownloadBriefModalProps) => {
  useEffect(() => {
    const scriptId = 'hubspot-embed-script';

    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/embed/7805184.js';
      script.defer = true;
      script.id = scriptId;

      document.body.appendChild(script);
    }
  }, []);

  return (
    <Modal
      sx={{
        zIndex: zIndex.modal,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      open={isOpen}
      onClose={onClose}
      aria-labelledby="download-brief-modal-title"
      aria-describedby="download-brief-modal-description"
      slots={{
        backdrop: (props) => (
          <Backdrop
            {...props}
            sx={{
              backdropFilter: 'blur(5px)',
              backgroundColor: 'rgba(0,0,0,0.2)',
            }}
          />
        ),
      }}
    >
      <Box
        sx={{
          backgroundColor: colors.white,
          minHeight: '150px',
          height: '100%',
          maxHeight: '600px',
          overflow: 'auto',
          width: '100%',
          maxWidth: {
            sm: '722px',
            xxs: 'calc(100% - 40px)',
          },
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
        }}
      >
        <script src="https://js.hsforms.net/forms/embed/7805184.js" defer></script>

        <div
          className="hs-form-frame"
          data-region="na1"
          data-form-id="28f6401d-dc41-40d6-91e3-3b7525c71c68"
          data-portal-id="7805184"
        />
      </Box>
    </Modal>
  );
};
